module.exports = "/images/Collect customer data.svg?18dc876377571cac63ff24404463e98b";